<template>
  <div class="notice">
    <div class="panel panel-default">
      <div class="panel-heading">
        <h4 class="panel-title">
          <span class="notice-img">
            <img :src="notice.src" alt />
          </span>
          &nbsp;{{notice.title}}
          <template v-if=" num===2 ">
            <a href="purchase.html?num=2" class="pull-right a-more">更多&gt;</a>
          </template>
          <template v-if="morelink">
            <span @click="moreLinkEvent(morelink)" class="pull-right a-more">更多&gt;</span>

            <!-- <a target="_blank" href="#" @click="moreLinkEvent(morelink)" class="pull-right a-more">更多&gt;</a> -->
          </template>
        </h4>
      </div>
      <div class="panel-body min-height" v-if="type != 'cgnotice'">
        <template v-if="notice.content">
          <div v-for="info in notice.content">
            <a
              href="javascript:;"
              :title="info.messageTitle||info.title"
              class="list-group-item list-padding"                                                  
              @click="detailed(info)"
            >
              <span class="list-dot">·</span>
              &nbsp;{{info.messageTitle||info.title}}
            </a>
          </div>
        </template>
        <template v-else-if="!notice.content && notice.title!='友情链接'">
          <p class="notcie-error-handling">暂无数据</p>
        </template>
        <template v-if="notice.title=='友情链接'">
          <!-- <p class="friendlylink"><a href="http://www.yueyun.com/" target="_blank"><img src="static/imgs/logo_jg.png" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.mysteel.com/" target="_blank"><img src="static/imgs/wdgt.jpg" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.cfhi.com/yzjt/index.html" target="_blank"><img src="static/imgs/dyzxjx.jpg" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.shaangu.com/" target="_blank"><img src="static/imgs/sgdl.jpg" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.ccmn.cn/" target="_blank"><img src="static/imgs/cjys.jpg" alt=""></a></p>-->
        </template>
      </div>
      <div class="panel-body min-height" v-else>
        <template v-if="notice.content">
          <div v-for="info in notice.content">
            <a
              href="javascript:;"
              :title="info.title||info.subtitle"
              class="list-group-item list-padding"                                                  
              @click="detailed(info)"
            >
              <span class="list-dot">·</span>
              &nbsp;{{info.title||info.subtitle}}
            </a>
          </div>
        </template>
        <template v-else-if="!notice.content && notice.title!='友情链接'">
          <p class="notcie-error-handling">暂无数据</p>
        </template>
        <template v-if="notice.title=='友情链接'">
          <!-- <p class="friendlylink"><a href="http://www.yueyun.com/" target="_blank"><img src="static/imgs/logo_jg.png" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.mysteel.com/" target="_blank"><img src="static/imgs/wdgt.jpg" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.cfhi.com/yzjt/index.html" target="_blank"><img src="static/imgs/dyzxjx.jpg" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.shaangu.com/" target="_blank"><img src="static/imgs/sgdl.jpg" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.ccmn.cn/" target="_blank"><img src="static/imgs/cjys.jpg" alt=""></a></p>-->
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
.list-group-item {
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}

.notice-img {
  position: relative;
  top: -1px;
}

.a-more {
  font-size: 13px;
  color: #666666 !important;
  position: relative;
  top: 1px;
}

.a-more:hover {
  text-decoration: none;
  padding-bottom: 5px;
  border-bottom: 1px solid #1983d7;
  color: #1983d7 !important;
}

.notice .panel {
  border-radius: 0px;
}

.min-height {
  min-height: 247px;
}

.min-height > div {
  cursor: pointer;
}

.notcie-error-handling {
  text-align: center;
  margin-top: 80px;
}

.friendlylink img {
  width: 240px;
}
</style>

<script>
/*eslint-disable*/
import { apiLinks } from '../api/links.js'
// import cookies from "vue-cookies";
import { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

export default {
  name: 'notice',
  props: {
    // 基础类型检测 （`null` 意思是任何类型都可以）
    type: '',
    apiUrl: '',
    num: '',
    ajaxType: '',
    morelink: ''
  },
  data () {
    return {
      notice: '',
      companyNotices: {
        src: 'static/imgs/companynotice.png',
        title: '企业公告',
        content: ''
      },
      biddingNotices: {
        src: 'static/imgs/bidnotice.png',
        title: '中标公告',
        content: ''
      },
      clarifyNotices: {
        src: 'static/imgs/clearnotice.png',
        title: '澄清公告',
        content: ''
      },
      links: {
        src: 'static/imgs/friendlinks.png',
        title: '友情链接',
        content: ''
      },
      lbNotices: {
        src: 'static/imgs/bidnotice.png',
        title: '流标公告',
        content: ''
      },
      cqNotices: {
        src: 'static/imgs/bidnotice.png',
        title: '澄清公告',
        content: ''
      },
      cgNotices: {
        src: 'static/imgs/bidnotice.png',
        title: '物资采购招标公告',
        content: ''
      }
    }
  },
  mounted: function () {
    this.staticData(this.type)
    if (this.apiUrl !== '') {
      this.getDate()
    }
  },
  methods: {
    getDate: function () {
      if (this.type == 'company') {
        this.$http.post(this.apiUrl, {
          "tenantId": apiLinks.tenantId,//'fkfvz45r'
          "pageNum": 0,
          "pageSize": 6
        }).then(function (response) {
          this.notice.content = response.data.data.list
          // console.log(1,response,this.notice.content)
        }, function (response) {
        })
      } else {
        switch (this.ajaxType) {
          case 'get':
            this.$http.get(this.apiUrl).then(function (response) {
              this.notice.content = response.data.data.results
              // console.log(2,response,this.notice.content)
            }, function (response) {
            })
            break
          default:
            this.$http.jsonp(this.apiUrl, []).then(function (response) {
              this.notice.content = response.data[0]['result']
              // console.log(3,response,this.notice.content)

            }, function (response) {
            })
            break
        }
      }
    },
    moreLinkEvent(href){
      console.log(this.type,localStorage.user)
      if(this.type == 'company' || this.type == 'lbnotice'){
        // const yht_access_token = localStorage.user
        if(!localStorage.user){
          Message({
              message: '未登录，不能进行查看！',
              type: 'error'
            });
        }else{
          window.open(href)
        }
      }else{
        window.open(href)
      }
    },
    staticData: function (type) {
      switch (type) {
        case 'company':
          this.notice = this.companyNotices
          break
        case 'bidding':
          this.notice = this.biddingNotices
          break
        case 'clarify':
          this.notice = this.clarifyNotices
          break
        case 'links':
          this.notice = this.links
          break
        case 'lbnotice':
          this.notice = this.lbNotices
          break
        case 'cqnotice':
          this.notice = this.cqNotices
          break
        case 'cgnotice':
          this.notice = this.cgNotices
          this.getNotice()
          break
        default:
          break
      }
    },
    getNotice(){
      $.ajax({
        url: '/yuncai/notice/getPunoticeList',
        type: 'post',
        data: JSON.stringify({pageSize:6,pageNo:0,isPublish: 1}),
        contentType: 'application/json',
        success: (response)=> {
          this.notice.content = JSON.parse(response)&&JSON.parse(response).data&&JSON.parse(response).data.resultList
        }
      })
    },
    detailed: function (info) {
      switch (this.type) {
        case 'company':
          window.open(apiLinks.details['company'] + info.id)
          break
        case 'lbnotice':
          window.open(apiLinks.details['lbNotice'] + info.msgId + '&enterpriseId=' + info.srcEnterpriseId)
          break
        case 'cqnotice':
          window.open(apiLinks.details['cqNotice'] + info.msgId + '&enterpriseId=' + info.srcEnterpriseId)
          break
        case 'cgnotice':
          window.open(apiLinks.details['cgNotice'] + info.id)
          break
        default:
          if (info.href) {
            window.open(info.href)
          } else {
            var url = ''
            switch (parseInt(info.messageTypeShow)) {
              case 5: // 物资
                url = apiLinks.details['bidMsg'] + info.msgId
                break;
              case 7: // 物流
                url = apiLinks.details['bidMsg'] + info.msgId
                break;
              case 13: // 工程
                url = apiLinks.details['bidMsg'] + info.msgId
                break;
              case 14: // 服务
                url = apiLinks.details['bidMsg'] + info.msgId
                break;
              case 10:
                url = apiLinks.details['bidMsg2'] + info.msgId
                break;
              case 17:
                url = apiLinks.details['bidMsg3'] + info.msgId
                break;
              default:
                url = apiLinks.details['bidDetails'] + info.msgId
                break
            }
            window.open(url)
          }
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// notice.vue?23e4c1ea